const formatResourceLabel = (input: string) => {
	// Use regex to insert a space before capital letters, except for the first character
	let formattedString = input.replace(/([A-Z])/g, " $1").trim();

	// Capitalize the first letter
	return formattedString.charAt(0).toUpperCase() + formattedString.slice(1);
};

export default formatResourceLabel;
